import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import Loading from "../Loading";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    CardWrapper,
    SelectionCard,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    MobileIcon
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import Config from "../../Config";
import * as Yup from "yup";

const BasicDetails = ({ onClose, data, selectedData, stepOneData, addBasicDetailMutate, addBasicDeailLoading, propId, roomId, route }) => {
    const propInfo = data?.data?.data

    const initialValues = React.useMemo(() => ({
        fullName: "",
        mobile: "",
        alternateMobile: "",
        gender: "",
        occupation: "",
        entireFlatOccupied: false,
        allBedsOccupied: false,
        bedId: selectedData?.bed?.id,
        propId: propId,
        roomId: roomId,
        rentalBond: propInfo?.property?.isBondAvailable === Config.RENTAL_BOND.MANDATORY,
    }), [propInfo]);


    const gender = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
    ];

    const occupation = [
        { value: "Professional", label: "Professional" },
        { value: "Student", label: "Student" },
    ];

    const handleSubmit = (values) => {
        const nameRegex = /^[A-Za-z0-9. ]{4,}$/;
        const mobileRegex = /^\d{10}$/;

        // if (!values.occupation || !values.mobile || !values.fullName) {
        //     toast.error("All Fields are required");
        //     return;
        // }

        if (!nameRegex.test(values.fullName)) {
            toast.error("Only letters, numbers, spaces & dots are allowed.");
            return;
        }

        if (!mobileRegex.test(values.mobile)) {
            toast.error("Mobile number should be exactly 10 digits long and contain only numbers");
            return;
        }

        if (values.alternateMobile && !mobileRegex.test(values.alternateMobile)) {
            toast.error("Alternate number should be exactly 10 digits long and contain only numbers");
            return;
        }

        let selectedGender = "";
        if (propInfo?.property?.tenantPreference === Config.GENDER_PREFERENCE.MALE) {
            selectedGender = Config.GENDER_PREFERENCE.MALE;
        } else if (propInfo?.property?.tenantPreference === Config.GENDER_PREFERENCE.FEMALE) {
            selectedGender = Config.GENDER_PREFERENCE.FEMALE;
        } else if (propInfo?.property?.tenantPreference === Config.GENDER_PREFERENCE.BOTH) {
            selectedGender = values.gender;
            if (!selectedGender) {
                toast.error("Gender selection is required");
                return;
            }
        }

        addBasicDetailMutate({
            fullName: values.fullName,
            mobile: values.mobile,
            gender: Number(selectedGender),
            occupation: String(values.occupation),
            allBedsOccupied: values.allBedsOccupied,
            alternateMobile: values.alternateMobile,
            entireFlatOccupied: values.entireFlatOccupied,
            bedId: selectedData?.bed?.id,
            propId: Number(propId),
            roomId: Number(roomId),
            isRentalBondAllowed:
                propInfo?.property?.isBondAvailable === Config.RENTAL_BOND.MANDATORY && values.rentalBond
                    ? 2
                    : 1,

        });

    };

    const validationSchema = Yup.object({
        fullName: Yup.string()
            .required('Name is required')
            .matches(/^[A-Za-z0-9. ]{4,}$/, 'Only letters, numbers, dot and spaces allowed. Minimum 4 characters.'),

        mobile: Yup.string()
            .required('Mobile number is required')
            .matches(/^\d{10}$/, 'Enter a valid 10-digit mobile number'),
        occupation: Yup.string().required("Please select Occupation"),
    });
    if (!propInfo) return <Loading />;

    return (

        <Formik initialValues={stepOneData || initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>

            {({ values, errors, setFieldValue, touched }) => (
                <Form >
                    <ModalSubHeading>{route === 'selectProperty' ? "Step 2" : "Step 1"}</ModalSubHeading>
                    <ModalHeading>Basic Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="fullName">Name *</Label>
                                <FieldWrappers>
                                    <Field
                                        type="text"
                                        name="fullName"
                                        id="fullName"
                                        autoComplete="off"
                                    />
                                </FieldWrappers>
                                {touched.fullName && errors.fullName && (
                                    <p className="text-rose-600 text-sm">
                                        {errors.fullName}
                                    </p>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="mobile">Mobile *</Label>
                                <FieldWrappers>
                                    <MobileIcon />
                                    <Field
                                        type="text"
                                        name="mobile"
                                        id="mobile"
                                        inputMode="numeric"
                                        autoComplete="off"
                                        maxLength={10}
                                        className="pl-5"
                                    />
                                </FieldWrappers>
                                {touched.mobile && errors.mobile && (
                                    <p className="text-rose-600 text-sm">
                                        {errors.mobile}
                                    </p>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="alternateMobile">Emergency Mobile</Label>
                                <FieldWrappers>
                                    <MobileIcon />
                                    <Field
                                        type="text"
                                        name="alternateMobile"
                                        id="alternateMobile"
                                        inputMode="numeric"
                                        maxLength={10}
                                        autoComplete="off"
                                        className="pl-5"
                                    />
                                </FieldWrappers>
                            </InputGroup>
                            {(propInfo?.property?.tenantPreference === Config.GENDER_PREFERENCE.BOTH) && (
                                <InputGroup>
                                    <Label>Gender *</Label>
                                    <CardWrapper>
                                        {gender.map((mode) => (
                                            <SelectionCard
                                                key={mode.value}
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFieldValue("gender", mode.value, false);
                                                }}
                                                className={
                                                    values.gender === mode.value
                                                        ? "bg-[#0078BD] text-white"
                                                        : "bg-gray-100 text-gray-800"
                                                }
                                            >
                                                <span className="text-sm">{mode.label}</span>
                                            </SelectionCard>
                                        ))}
                                    </CardWrapper>
                                </InputGroup>)}

                            <InputGroup>
                                <Label>Occupation *</Label>
                                <CardWrapper>
                                    {occupation.map((mode) => (
                                        <SelectionCard
                                            key={mode.value}
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFieldValue("occupation", mode.value, false);
                                            }}
                                            className={
                                                values.occupation === mode.value
                                                    ? "bg-[#0078BD] text-white"
                                                    : "bg-gray-100 text-gray-600"
                                            }
                                        >
                                            <span className="text-sm">{mode.label}</span>
                                        </SelectionCard>
                                    ))}
                                </CardWrapper>
                                {touched.occupation && errors.occupation && (
                                    <p className="text-rose-600 text-sm">
                                        {errors.occupation}
                                    </p>
                                )}
                            </InputGroup>


                            {((selectedData?.item?.status === Config.ROOM_STATUS.VACANT &&
                                propInfo?.room?.type !== Config.ROOM_TYPES.SINGLE_SHARING) || selectedData?.item?.isFlatVacant === true) &&
                                <InputGroup>
                                    <Label>Occupy</Label>
                                    <CardWrapper>
                                        {(selectedData?.item?.status === Config.ROOM_STATUS.VACANT &&
                                            propInfo?.room?.type !== Config.ROOM_TYPES.SINGLE_SHARING) && (
                                                <label className="flex items-center space-x-2">
                                                    <Field
                                                        type="checkbox"
                                                        name="allBedsOccupied"
                                                        checked={values.allBedsOccupied}
                                                        onChange={(e) => {
                                                            setFieldValue("allBedsOccupied", e.target.checked);
                                                            if (e.target.checked) {
                                                                setFieldValue("entireFlatOccupied", false);
                                                            }
                                                        }}
                                                        className="form-checkbox h-4 w-4 text-blue-600"
                                                    />
                                                    <span className="text-sm text-gray-800">Entire Room</span>
                                                </label>)}
                                        {selectedData?.item?.isFlatVacant === true && (
                                            <label className="flex items-center space-x-2">
                                                <Field
                                                    type="checkbox"
                                                    name="entireFlatOccupied"
                                                    checked={values.entireFlatOccupied}
                                                    onChange={(e) => {
                                                        setFieldValue("entireFlatOccupied", e.target.checked);
                                                        if (e.target.checked) {
                                                            setFieldValue("allBedsOccupied", false);
                                                        }
                                                    }}
                                                    className="form-checkbox h-4 w-4 text-blue-600"
                                                />
                                                <span className="text-sm text-gray-800">Entire Flat</span>
                                            </label>)}
                                    </CardWrapper>
                                </InputGroup>}

                            {
                                propInfo?.property?.isBondAvailable === Config.RENTAL_BOND.MANDATORY &&
                                <InputGroup>
                                    <Label>Rental Bond</Label>

                                    <label className="flex items-center space-x-2">
                                        <Field
                                            type="checkbox"
                                            name="rentalBond"
                                            checked={values.rentalBond}
                                            onChange={(e) => {
                                                setFieldValue("rentalBond", e.target.checked);

                                            }}
                                            className="form-checkbox h-4 w-4 text-blue-600"
                                        />
                                        <span className="text-sm text-gray-800">Is Rental Bond Allowed?</span>
                                    </label>
                                </InputGroup>}

                        </Wrapper>

                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={onClose}>
                            {route ? "Back" : "Cancel"}
                        </SideCancelBtn>
                        <SubmitBtn type="submit" disabled={addBasicDeailLoading}>
                            {addBasicDeailLoading ? "Processing..." : "Next"}
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};

export default BasicDetails;